import { normalizeCampaignStatus } from "./campaignDisplayUtils";

const getPositiveWholeNumber = (value) => {
    const number = Number(value);

    return Number.isFinite(number) && number > 0 ? Math.trunc(number) : 0;
};

const getStepNumber = (step = {}) => getPositiveWholeNumber(step.step_number);

const getStepDelayDays = (step = {}) => {
    const value = step.delay_days ?? step.delay_days_from_previous;
    const number = Number(value);

    return Number.isFinite(number) ? number : null;
};

export const getCampaignNextStepInfo = (summary = {}, details = {}) => {
    const status = normalizeCampaignStatus(summary);
    const helperContext = summary?.ui_helper_context || {};
    const totalSteps = getPositiveWholeNumber(
        summary?.total_steps ?? details?.total_steps,
    );
    const currentStep = getPositiveWholeNumber(
        helperContext.current_active_step ??
            details?.ui_helper_context?.current_active_step,
    );
    const steps = Array.isArray(details?.steps) ? details.steps : [];

    if (status === "completed") {
        return {
            state: "completed",
            hasNextStep: false,
            currentStep,
            totalSteps,
            nextStep: null,
            delayDays: null,
            step: null,
        };
    }

    if (status !== "active") {
        return {
            state: status || "unknown",
            hasNextStep: false,
            currentStep,
            totalSteps,
            nextStep: null,
            delayDays: null,
            step: null,
        };
    }

    if (!currentStep || !totalSteps) {
        return {
            state: "unknown",
            hasNextStep: false,
            currentStep,
            totalSteps,
            nextStep: null,
            delayDays: null,
            step: null,
        };
    }

    const scheduledStepNumber = currentStep;
    const step = steps.find(
        (candidate) => getStepNumber(candidate) === scheduledStepNumber,
    );

    return {
        state: currentStep >= totalSteps ? "final-step" : "upcoming",
        hasNextStep: true,
        currentStep,
        totalSteps,
        nextStep: scheduledStepNumber,
        stepNumber: scheduledStepNumber,
        delayDays: step ? getStepDelayDays(step) : null,
        step: step || null,
    };
};
